// EXTERNAL IMPORTS
import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { connect } from "react-redux";
import { themr } from "react-css-themr";
// import { Switch, Route } from 'react-router-dom';
import { withRouter } from "react-router";
import { sideMenu } from "@lifepay/rc-ui-toolkit";
// import phoneSVG from "@lifepay/assets/sprites/feather/communication/phone.svg";
// import phonemissedSVG from "@lifepay/assets/sprites/feather/communication/phone-missed.svg";

// import Input from "@lifepay/rc-ui-toolkit/dist-modules/controls/Input";

// ABSOLUTE PATH IMPORTS
// importing object with action creator functions
import actions from "model/actions";
import selectors from "model/selectors";

import queryFactory, { client } from "model/gql/queries";

import Client from "components/emission/client-summary/Client";
import Company from "components/emission/client-summary/Company";
// import OktellControls from "components/emission/OktellControls";
import Call from "./Call";
// import mutationFactory, { blockCard } from "model/gql/mutations";

// RELATIVE PATH IMPORTS
// importing default component styles
import styles from "./ClientsList.m.scss";

const ClientData = queryFactory(client);

@withRouter
@connect(
  // mapStateToProps function - passes data from store's state.
  (state) => {
    return {
      oktellSync: selectors.clients.oktellSync$$(state),
      oktellSyncStateChanges: selectors.clients.oktellSyncStateChanges$$(state),
      calls: selectors.clients.callsArray$$(state),
      currentCall: selectors.clients.currentCall$$(state),
    };
  },
  // mapDispatchToProps object - pass individual action creators here
  {
    selectClient: actions.clients.selectClient,
    removeClient: actions.clients.removeClient,
    toggleOktellSync: actions.clients.toggleOktellSync,
  }
)
@themr("ClientsList", styles)
export default class ClientsList extends Component {
  static propTypes = {
    theme: PropTypes.object,
    history: PropTypes.object,
    currentCall: PropTypes.object,
    callInProgress: PropTypes.bool,
    oktellSync: PropTypes.bool,
    oktellSyncStateChanges: PropTypes.bool,
    calls: PropTypes.array,
    savedClients: PropTypes.array,
    selectClient: PropTypes.func,
    removeClient: PropTypes.func,
    toggleOktellSync: PropTypes.func,
    basePath: PropTypes.string,
  };

  continueWork = ({ id, type }) => {
    const { selectClient, history, basePath } = this.props;
    switch (type) {
      case "PERSON": {
        selectClient({ type, id: "p-" + id });
        history.push(`${basePath}/p-${id}/menu`);
        break;
      }
      case "COMPANY": {
        selectClient({ type, id: "c-" + id });
        history.push(`${basePath}/c-${id}/menu`);
        break;
      }
    }
  };

  endWork = ({ id, type }) => {
    const { removeClient } = this.props;
    switch (type) {
      case "PERSON": {
        removeClient({ type, id: "p-" + id });
        break;
      }
      case "COMPANY": {
        removeClient({ type, id: "c-" + id });
        break;
      }
    }
  };

  render() {
    const { theme, savedClients, calls, currentCall } = this.props;
    return (
      <div className={classnames(theme.wrapper)}>
        <sideMenu.Info header={"История звонков"} hideContent={true}>
          <div className={classnames(theme.calls)}>
            {calls.slice(Math.max(calls.length - 3, 0)).map((call) => (
              <Call key={call.id} item={call} />
            ))}
          </div>
        </sideMenu.Info>
        <sideMenu.Info header={"Клиенты"} hideContent={false}>
          {savedClients.map((client) => {
            return (
              <ClientData
                key={client.id}
                id={client.remoteId}
                type={client.type}
              >
                {({ data, loaded }) => {
                  switch (client.type) {
                    case "PERSON": {
                      const clientData =
                        data && data.clients && data.clients[0];
                      return clientData ? (
                        <sideMenu.Info>
                          <Client
                            client={clientData}
                            onCall={
                              currentCall &&
                              currentCall.client &&
                              currentCall.client.remoteId === clientData.id
                            }
                            continueWork={this.continueWork}
                            endWork={this.endWork}
                          />
                        </sideMenu.Info>
                      ) : null;
                    }
                    case "COMPANY": {
                      const clientData =
                        data && data.companies && data.companies[0];
                      return clientData ? (
                        <sideMenu.Info>
                          <Company
                            company={clientData}
                            continueWork={this.continueWork}
                            endWork={this.endWork}
                          />
                        </sideMenu.Info>
                      ) : null;
                    }
                    default: {
                      return null;
                    }
                  }
                }}
              </ClientData>
            );
          })}
        </sideMenu.Info>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Private/pages/workflow-client/side-menu/ClientsList/ClientsList.js